module.exports = __webpack_public_path__ + "static/media/myImg.479647ff.jpg";